import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import RenderDate from "../../../Common/Date/RenderDate";

function ScopeOfWorkInfoDialog({ open, onClose, data = {} }) {
    return (
        <Dialog open={open} fullWidth>
            <DialogTitle>Scope of work</DialogTitle>
            <DialogContent dividers={false}>
                <dl className="list-data">
                    <dt>Area</dt>
                    <dd>{data.area}</dd>
                    <dt>Contract</dt>
                    <dd>{data.contract}</dd>
                    <dt>Start date</dt>
                    <dd>
                        <RenderDate date={data.dateStart} />
                    </dd>
                    <dt>End date</dt>
                    <dd>
                        <RenderDate date={data.dateEnd} />
                    </dd>
                    <dt>Organisation</dt>
                    <dd>{data.organisation?.name}</dd>
                    <dt>Time committed</dt>
                    <dd>{data.practicePercent}</dd>
                    <dt>Work</dt>
                    <dd>{data.work}</dd>
                    <dt>Description</dt>
                    <dd>{data.description}</dd>
                </dl>
            </DialogContent>
            <DialogActions>
                <Button key="close" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ScopeOfWorkInfoDialog;
